export const SELECT_VENDOR = 'SELECT_VENDOR';
export const DESELECT_VENDOR = 'DESELECT_VENDOR';

